jQuery(document).ready(function(){
	checkAnimatedBlock();
})

function checkAnimatedBlock(){
	let animatedBlocks = jQuery('.animate__animated.animation-extend');
	animatedBlocks.each(function(){
		let block = jQuery(this);
		let tempBlock = jQuery('<div/>')
			.css('min-height', block.outerHeight(true))
			.css('min-width', block.outerWidth(true))
			.css('position', 'relative')
			.addClass('animation-temp-block');
		checkIfItemIsVisible(
			block,
			()=>{
				if(block.hasClass("paused")){
					setTimeout(function(){
						block.addClass("play");
						block.removeClass("paused");
					},100);
					setTimeout(function(){
						block.removeClass("play");
						block.addClass("ended")
					}, 350)
				}
			},
			()=>{if(block.hasClass("animation-loop"))block.addClass('paused')}
		);
	})
}

const options = {
	threshold: .10, // % de l'item qui doit être visible pour lancer l'animation, entre 0 et 1 (1 = 100% de l'item)
}

function checkIfItemIsVisible(item, callBackTrue=()=>{}, callBackFalse=()=>{}){
	const observer = new IntersectionObserver(intersectionHandler=(entries)=>{
		entries.map((entry) => {(entry.isIntersecting) ? callBackTrue() : callBackFalse();});
	}, options);
	observer.observe(item[0]);
}
